export default __webpack_public_path__ + "static/media/80.6793a6c3.jpeg";